import now from 'lodash/fp/now';

const isCardExpired = (year: number, month: number, day: number | null) => {
  const expiredDate = new Date(year, month, day as number).getTime();
  const currentDate = now();

  return currentDate >= expiredDate;
};

export default isCardExpired;
